import * as XLSX from "xlsx";

function safeSheetName(value) {
  return String(value || "Employees")
    .replace(/[\\/*?:[\]]/g, "")
    .slice(0, 31);
}

function safeFileName(value) {
  return String(value || "")
    .trim()
    .replace(/[^\w-]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

function fullName(row) {
  return (
    `${row.first_name || ""} ${row.last_name || ""}`.trim() ||
    row.employee_name ||
    "-"
  );
}

export function exportPayrollEmployeesExcel({
  company,
  employees = [],
  fileLabel = "Employees_List",
}) {
  const rows = (employees || []).map((row, index) => ({
    S_N: index + 1,
    Employee_Code: row.employee_code || "",
    Employee_Name: fullName(row),
    Department: row.department || "",
    Job_Title: row.job_title || "",
    Level: row.job_level_name || "",
    Grade: row.job_grade_name || "",
    Employment_Type: row.employment_type || "",
    Employment_Status: row.employment_status || "",
    Salary_Basis: row.salary_basis || "",
    Base_Salary: Number(row.base_salary || 0),
    Currency: row.currency_code || "NGN",
    Bank_Name: row.bank_name || "",
    Account_Name: row.bank_account_name || "",
    Account_Number: row.bank_account_number || "",
    Work_Email: row.work_email || "",
    Personal_Email: row.personal_email || "",
    Phone: row.phone || "",
    Hire_Date: row.hire_date || "",
    Tenant: row.is_tenant ? "Yes" : "No",
    Annual_Rent_Paid: row.is_tenant ? Number(row.annual_rent_paid || 0) : "",
  }));

  const worksheet = XLSX.utils.json_to_sheet(rows.length ? rows : [{}]);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    safeSheetName(fileLabel || "Employees")
  );

  XLSX.writeFile(
    workbook,
    `${safeFileName(company?.company_name || "Company")}_${safeFileName(
      fileLabel
    )}.xlsx`
  );
}
